import {Validator} from '@library/core-validation/src/lib/validators/validator';
import {NgModel} from '@angular/forms';

export class NgModelValidator implements Validator<NgModel> {
    validate(value: NgModel): boolean {
        return value.valid;
    }
}
